import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth/AuthContext';

type Props = {
  children: React.ReactNode;
};

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { initialized, session } = useAuth();
  const location = useLocation();

  if (!initialized) {
    return (
      <div className="flex min-h-svh flex-1 flex-col items-center justify-center bg-background px-6">
        <p className="text-sm text-textSecondary">Loading…</p>
      </div>
    );
  }

  if (!session) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  return <>{children}</>;
};
